import React from 'react';
import './InfoModal.scss';

const InfoModal = ({ isOpen, onClose, lang }) => {
  if (!isOpen) return null;

  const infoText = lang === 'de'
    ? "klicke irgendwo auf die seite, um eine beschimpfung oder ein lob zu generieren. klicke auf die linke seite für eine beschimpfung und auf die rechte seite für ein lob. du kannst auch die sprache wechseln, indem du auf die entsprechenden buttons klickst."
    : "click anywhere on the page to generate an insult or a praise. click on the left side for an insult and on the right side for a praise. you can also switch the language by clicking on the corresponding buttons.";

  const copyrightText = lang === 'de' ? "2026 joerg piringer" : "2026 joerg piringer";

  return (
    <div className="info-modal-overlay" onClick={onClose}>
      <div className="info-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="info-modal-close" onClick={onClose}>×</button>
        <h2>{lang === 'de' ? 'beschimpfung oder lob' : 'insult or praise'}</h2>
        <p>{infoText}</p>
        <p className="copyright">{copyrightText}</p>
		<a href="https://joerg.piringer.net" target="_blank" rel="noopener noreferrer">{lang === 'de' ? 'https://joerg.piringer.net' : 'https://joerg.piringer.net'}</a>
      </div>
    </div>
  );
};

export default InfoModal;
